import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/public/auth/auth.service';
import { customValidators } from 'src/app/_helpers/customValidators';
import { error } from 'src/app/_helpers/log';
import { AuthenticationService } from './../../../_services/authentication.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit, OnDestroy {

  constructor(
    public modalController: ModalController,
    private toastCtrl: ToastController,
    public translate: TranslateService,
    private authServ: AuthService,
    private authenticationServ: AuthenticationService
  ) { }
  destroy$: Subject<boolean> = new Subject<boolean>();

  form: FormGroup;
  validationError: boolean = false;
  showErrorText: boolean = false;
  disableSaveButton: boolean = false;

  ngOnInit() {
    this.form = new FormGroup(
      {
        oldPassword: new FormControl(
          null, {
            updateOn: "blur",
            validators: [
              Validators.required,
            ]
          }
        ),
        newPassword: new FormControl(
          null, {
            updateOn: "blur",
            validators: [
              Validators.required,
              Validators.minLength(8),
              Validators.maxLength(30),
            ]
          }
        ),
        newPasswordAgain: new FormControl(
          null, {
            updateOn: "blur",
            validators: [
              Validators.required,
              Validators.minLength(8),
              Validators.maxLength(30),
            ]
          }
        ) 
      },
      customValidators.samePasswords("newPassword", "newPasswordAgain")
    );
  }

  back() {
    this.modalController.dismiss();
  }
  
  async onSubmit() {
    this.disableSaveButton = true;

    if (!this.form.valid) {
      this.validationError = true;
      this.disableSaveButton = false;
      return;
    }

    const toast = await this.toastCtrl.create({
      message: this.translate.instant("SAVED"),
      duration: 1000,
      color: "dark",
    });

    const {
      oldPassword,
      newPassword
    } = this.form.value;

    const data = {
      oldPassword: oldPassword,
      newPassword: newPassword
    }

    this.authServ
      .changeUserPassword(data)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (e) => {
          this.modalController.dismiss();
          this.authenticationServ.setNewTokens(e.token, e.refreshToken);
          toast.present();
        },
        error: (err: HttpErrorResponse) => {
          error(err.error.message);
          this.showErrorText = true;
          this.disableSaveButton = false;
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
